import {
	ILinkMaterialDto,
	IDocumentMaterialDto,
	ISimplifiedVisualMaterialDto,
	IMaterialDto,
	ICloudScannerLinkDto,
} from './dtos'
import { ILinkMaterial, IDocumentMaterial, ISimplifiedVisualMaterial } from './models'
import { ProductCategory } from '../packages/models'

export function mapCloudScannerLinkFromDto({ linkType, url }: ICloudScannerLinkDto) {
	return {
		type: linkType,
		url,
	}
}

export function mapSimplifiedVisualMaterialFromDto(
	materialDto: ISimplifiedVisualMaterialDto
): ISimplifiedVisualMaterial {
	return {
		...materialDto,
		largestSource: materialDto.originalLargestMaterialUrl,
		orderlineId: materialDto.orderLineId,
		batchId: materialDto.batchId?.toString(),
		updatedDate: materialDto?.originalMaterialAsset?.updatedDate
			? new Date(materialDto.originalMaterialAsset.updatedDate)
			: undefined,
		isSelected: false,
		isIFPMaterial: false,
		productCategory: materialDto.productCategory as ProductCategory,
		type: materialDto.originalMaterialAssetType,
		before: materialDto.materialBefore,
		after: materialDto.materialAfter,
		vendorOrderLineId: materialDto.vendorOrderLineId || undefined,
		cloudScannerLinks: materialDto.cloudScannerLinks?.map(mapCloudScannerLinkFromDto) || [],
	}
}

export function mapLinkOrDocumentMaterialFromDto<T extends ILinkMaterial | IDocumentMaterial>(
	materialDto: ILinkMaterialDto | IDocumentMaterialDto
) {
	const { id, description, type, url } = materialDto

	return {
		id,
		isActive: true,
		isSelected: false,
		name: description,
		url,
		type,
		_dto: materialDto,
	} as unknown as T
}

export function mapLinkOrDocumentMaterialToDto(material: ILinkMaterial | IDocumentMaterial): IMaterialDto {
	const { id, name, type, url } = material

	return {
		id: id as number,
		url,
		description: name!,
		type,
	}
}
